export default function isBlank(str){
    return !str || str.length === 0 || !/\S/.test(String(str));
}
